import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Barrierefreiheit() {
  return (
    <LegalPage
      title="Erklärung zur Barrierefreiheit"
      subtitle="Wir bauen eine Software, die alle nutzen können"
      lastUpdated="22. April 2026"
      testid="page-barrierefreiheit"
    >
      <p>
        Easy Gutachter ist bestrebt, seine digitalen Angebote im Einklang mit dem Barrierefreiheitsstärkungsgesetz (BFSG)
        und der Richtlinie (EU) 2019/882 barrierefrei zu gestalten.
      </p>

      <h2>Stand der Vereinbarkeit</h2>
      <p>
        Diese Anwendung ist <strong>weitgehend</strong> mit den Anforderungen der EN 301 549 (WCAG 2.1, Stufe AA) konform.
        Bekannte Einschränkungen werden in den nächsten Releases behoben.
      </p>

      <h2>Bekannte Einschränkungen</h2>
      <ul>
        <li>Einzelne Datei-Upload-Bereiche bieten derzeit nur Drag &amp; Drop. <em>Tastatur-Bedienung wird nachgerüstet.</em></li>
        <li>Die Live-Kamera-Aufnahme im Browser ist visuell konzipiert. Eine sprachgesteuerte Auslösung ist in Vorbereitung.</li>
      </ul>

      <h2>Was wir bereits umgesetzt haben</h2>
      <ul>
        <li>Vollständige Tastatur-Navigation in allen Formularen, Listen und Modalen.</li>
        <li>Sichtbarer Fokus-Rahmen auf allen interaktiven Elementen.</li>
        <li>Mindestkontrast-Verhältnis 4.5:1 für Texte und Icons.</li>
        <li>Skalierbare Schriftgröße (responsive bis 200 %).</li>
        <li>Screen-Reader-freundliche ARIA-Labels für alle Aktionen.</li>
        <li>Reduzierte Animationen bei <code>prefers-reduced-motion</code>.</li>
      </ul>

      <h2>Feedback &amp; Kontakt</h2>
      <p>
        Sind dir Mängel bei der Barrierefreiheit aufgefallen oder benötigst du Inhalte in einer anderen Form?
        Bitte schreibe an <a href="mailto:barrierefreiheit@easy-gutachter.de">barrierefreiheit@easy-gutachter.de</a>.
        Wir bestätigen den Eingang innerhalb von 2 Werktagen.
      </p>

      <h2>Schlichtungsverfahren</h2>
      <p>
        Solltest du auf unsere Antwort nicht zufrieden reagieren oder keine Antwort innerhalb von 6 Wochen erhalten,
        kannst du dich an die zuständige Schlichtungsstelle nach § 16 BGG wenden.
      </p>
    </LegalPage>
  );
}
